export default {"src":"/_next/static/media/stepsAnimation.0bd5305f.gif","height":1298,"width":1257,"blurWidth":0,"blurHeight":0};